import { toErrorMessage } from '@parleyride/hooks';

/**
 * Narrow an unknown thrown value to a human-readable message.
 *
 * Delegates to `@parleyride/hooks`'s `toError` so the web app and the shared
 * hooks normalise failures the same way — in particular, both read `.message`
 * off the plain `{ message, details, hint, code }` object PostgREST actually
 * returns rather than `String()`-ing it into `"[object Object]"`.
 */
export function getErrorMessage(error: unknown): string {
  return toErrorMessage(error);
}
